import React, { useState } from 'react';
// import main14 from './images/main-ads.png';

export default function WhyChooseContent() {
  // State to track the currently active tab
  const [activeTab, setActiveTab] = useState('Tab1');

  // Handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Content for each tab
  const renderContent = () => {
    switch (activeTab) {
      case 'Tab1':
        return (
          <div className="tab-contain-full">
            <div className="main-tab-heading1 auto-focus">
              <h1>Why Choose a Content Writing Agency?</h1>
            </div>
            <div className="main-para-area">
              <p>
                With over 1 billion websites online today, only about 10% succeed in achieving their desired presence. The main reason most sites fall short? Their on-page content doesn’t hit the mark.
              </p>
              <p>
                Creating effective web content requires careful attention to multiple factors to ensure high search engine rankings and audience engagement. At our agency, we craft content that not only reflects your brand’s voice but also connects meaningfully with your target audience, helping you stand out in the crowded digital space.
              </p>
              {/* <p>
                Explore the fundamentals of PPC marketing and discover how our expert pay per click marketing agency can help your business succeed.
              </p> */}
              <p></p>
            </div>
          </div>
        );
      case 'Tab2':
        return (
          <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>Why Outsource Content Writing Services?</h1>
            </div>
            <div className="main-para-area">
              <p>
                You can’t do it all alone—especially when Google considers over 200 factors to rank your website. By hiring professional content writers, you benefit from their expertise in optimizing content to deliver real ROI.
              </p>
              <p>When you partner with us, you’ll enjoy:</p>
              <ul>
                <li>Cost-effective solutions tailored to your budget</li>
                <li>Reliable and timely content delivery</li>
                <li>High-quality writing from experienced professionals</li>
                <li>Fast and flexible revisions</li>
                <li>Content crafted specifically for your target audience</li>
                <li>Regular quarterly performance reports to track progress</li>
              </ul>
              <p>
                Outsource your content writing to focus on what you do best, while we handle creating content that drives results.
              </p>
              <p></p>
            </div>
          </div>
        );
      case 'Tab3':
        return (
          <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>Why Choose Raj Digital Marketing?</h1>
            </div>
            <div className="main-para-area">
              <p>
                As a leading content writing agency, we leverage the latest SEO tools and strategies to ensure your brand stands out in the crowded digital landscape. Share your specific needs with us, and our expert writers will craft tailored web content solutions designed to highlight your business’s unique value.
              </p>
              <p>
                Beyond delivering SEO-friendly content, we excel in providing a wide range of high-quality content writing services that empower clients across industries to gain a competitive edge in SEO and digital marketing.
              </p>
              <p>What are some key requirements that web content must meet?</p>
              <ul>
                <li>Be written by skilled expert writers</li>
                <li>Be 100% unique and plagiarism-free</li>
                <li>Provide real value to the readers</li>
                <li>Be SEO-friendly</li>
                <li>Be original and engaging</li>
                <li>Include compelling headers and precise information</li>
                <li>Offer personalized content tailored for brands</li>
                <li>Undergo professional quality control to ensure value addition</li>
              </ul>
              <p></p>
            </div>
          </div>
        );
      default:
        return <div>Select a tab to see content</div>;
    }
  };

  return (
    <>
      {/* <div className="container main-ads-img-01">
        <div className="main-ads-img01">
          <img src={main14} alt="Main Advertisement" />
        </div>
      </div> */}

      <div className="container tabs-ads-main-container">
        <div className="row row-cols-2 tab-area-main">
          <div className="col main-tabs-area">
            <ul className="main-tab-list">
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab1')} autoFocus style={{ outline: 0 }}>
                  Why Choose a Content ...
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab2')}>
                  Why Outsource Content ...
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab3')}>
                  How Does PPC Marketing Work?
                </button>
              </li>
              {/* <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab4')}>
                  Why Pay Per Click Marketing Works...
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab5')}>
                  PPC Agency That Delivers Results
                </button>
              </li> */}
            </ul>
          </div>
          <div className="col main-contain-area-tabs">
            {renderContent()}
          </div>
        </div>
      </div>
    </>
  );
}
